import { createTheme, MantineColorsTuple } from "@mantine/core";

/** Logo orange (~#F27A21) as primary shade 6 */
const brand: MantineColorsTuple = [
  "#fff4eb",
  "#ffe4cc",
  "#ffc894",
  "#ffab5c",
  "#ff9333",
  "#f9841a",
  "#F27A21",
  "#d96512",
  "#b5520e",
  "#8c3d0a",
];

/** Charcoal for marketing chrome */
const charcoal: MantineColorsTuple = [
  "#f2f2f3",
  "#e0e0e2",
  "#c0c1c4",
  "#9a9b9f",
  "#6d6e71",
  "#4a4b4e",
  "#2c2d30",
  "#1f2023",
  "#161618",
  "#0d0d0e",
];

export const theme = createTheme({
  primaryColor: "brand",
  primaryShade: 6,
  colors: {
    brand,
    charcoal,
  },
  fontFamily:
    '"Source Sans 3", system-ui, -apple-system, BlinkMacSystemFont, sans-serif',
  headings: {
    fontFamily: '"Sora", system-ui, -apple-system, BlinkMacSystemFont, sans-serif',
    fontWeight: "600",
  },
  defaultRadius: "md",
  components: {
    Button: {
      defaultProps: {
        radius: "md",
      },
    },
  },
});
